/**
 * @module components\ghCodeEditor
 */
import Vue from "vue";
import Component from "vue-class-component";
import * as monco from "monaco-editor";
import { Prop, Model, Watch } from "vue-property-decorator";
import { MethodService } from "@/utils/serviceModel";

// async function registSnippet() {
//   console.log("invoke registSnippet");
//   let service = new MethodService(
//     "dynamic_parse_page",
//     "5cde0ac0d108614b2c60d83b",
//     "query"
//   );
//   let args = { keyword: "" };
//   try {
//     await service.invokeAsyn(args);
//     let snippets: { [key: string]: monco.languages.CompletionItem[] } = {};
//     if (service.isSuccess) {
//       let data = service.data[1] as IndexObject[];
//       for (const iterator of data) {
//         if (!snippets[iterator.Language]) {
//           snippets[iterator.Language] = [];
//         }
//         snippets[iterator.Language].push({
//           label: iterator.Cd,
//           kind: iterator.Kind,
//           insertText: iterator.Snippet,
//           range: {
//             startColumn: 1,
//             endColumn: 1,
//             startLineNumber: 1,
//             endLineNumber: 1
//           }
//         });
//       }
//       for (const key in snippets) {
//         if (snippets.hasOwnProperty(key)) {
//           const lst = snippets[key];
//           monco.languages.registerCompletionItemProvider(key, {
//             provideCompletionItems(model, position, context, token) {

//               return {
//                 suggestions: lst
//               };
//             }
//           });
//         }
//       }
//     }
//   } catch (error) {}
// }
// registSnippet();
const template: monco.editor.IEditorConstructionOptions = {
  readOnly: false,
  language: "python",
  autoIndent: true
};
@Component
export default class GhCodeEditor extends Vue {
  @Model("input", { default: "" })
  private value!: string;
  @Prop({ default: "代码编辑" })
  private title!: string;

  @Prop({ default: 200 })
  private height!: number;

  @Prop({
    default: () => {
      return {
        selectOnLineNumbers: true,
        roundedSelection: false,
        readOnly: false,
        cursorStyle: "line",
        automaticLayout: true,
        glyphMargin: true,
        useTabStops: false,
        autoIndent: true
      };
    }
  })
  private options!: monco.editor.IEditorConstructionOptions;

  @Prop({ default: true })
  private showActions!: boolean;

  private get ShowActions() {
    if (this.options.readOnly) {
      return false;
    }
    return this.showActions;
  }

  private editor: monco.editor.IStandaloneCodeEditor | null = null;

  private get div(): HTMLElement {
    return this.$refs.container as HTMLElement;
  }
  @Watch("value")
  private observeValue() {
    if (this.editor) {
      if (this.editor.getValue() !== this.value) {
        this.editor.setValue(this.value);
      }
      // let value = this.value ? this.value : "";
      // this.editor.setValue(value);
    }
  }

  @Watch("options.language")
  private observeOptions() {
    this.intial();
  }

  private test() {
    // monco.languages.registerCompletionItemProvider()
  }

  private intial() {
    if (this.div) {
      if (this.editor) {
        this.editor.dispose();
      }
      this.editor = monco.editor.create(this.div, this.options);
      if (this.editor) {
        let editor = this.editor as monco.editor.IStandaloneCodeEditor;
        editor.onDidChangeModelContent(event => {
          let value = editor.getValue();
          this.$emit("input", value);
        });
        this.editor.setValue(this.value);
      }

      // this.observeValue();
    }
  }

  mounted() {
    this.intial();
  }

  private cancel() {
    if (this.editor && this.value) {
      this.editor.setValue(this.value);
    }
    this.$emit("cancel");
  }
  public submit() {
    if (this.editor) {
      // this.$emit("input", this.editor.getValue());
      this.$emit("submit", this.editor.getValue());
    }

    // Vue.com
  }
}
